import React from "react";
import MaterialTable from "../../components/Table/MaterialTable";

const DataGridTemplate = ({
  columns,
  data,
  onEdit,
  onView,
  onDelete,
  onSwitch,
  printTitle,
  actions,
  selection,
  selectedData,
  setSelectedData,
  enableRowActions,
  positionActionsColumn,
  switchParams,
  ...props
}) => {
  // Process columns similar to your existing DataGrid logic
  const processedColumns = columns
    .map((e) => ({
      field: e.field,
      title:
        (e.title === switchParams?.key ?? "hidden_status") ? "Status" : e.title,
      hidden: e.hidden === true ? true : false,
      width: e.width,
      type: e.type,
      value: e.value,
      onChange: e.onChange,
      onBlur: e.onBlur,
      valueOptions: e.valueOptions,
      dynamicValueOption: e.dynamicValueOption,
      onClick: e.onClick,
      name: e.name,
    }))
    .filter(
      (e) => e.title.toLowerCase() !== "id" && !e.title.includes("hidden")
    )
    .sort((a, b) => {
      const aIsStatus = a.title.toLowerCase().includes("status");
      const bIsStatus = b.title.toLowerCase().includes("status");
      return aIsStatus ? (bIsStatus ? 0 : 1) : bIsStatus ? -1 : 0;
    });

  return (
    <MaterialTable
      columns={processedColumns}
      data={data}
      onEdit={onEdit}
      onView={onView}
      onDelete={onDelete}
      onSwitch={onSwitch}
      printTitle={printTitle}
      actions={actions}
      selection={selection}
      selectedData={selectedData}
      setSelectedData={setSelectedData}
      enableRowActions={enableRowActions}
      positionActionsColumn={positionActionsColumn}
      switchParams={switchParams}
      {...props}
    />
  );
};

export default DataGridTemplate;
